export const capitalizeFirstLetter = (word: string): string => {
  return word.charAt(0).toUpperCase() + word.slice(1);
};

export function truncateStringToMaxLength(string: string, maxLength: number): string {
  return string.length > maxLength ? `${string.substring(0, maxLength)}...` : string;
}
